module.exports = __webpack_public_path__ + "static/HKGroteskPro-Regular-d3fe612c4ff91d75fa1c1c6902617cad.woff2";